//import styled from "styled-components";
import { useHistory } from "react-router";
//import { AiOutlineRollback } from "react-icons/ai";
import { JumpBtn } from ".";

// const Container = styled.div`
//     display: inline-flex;
//     align-items: center;
//     padding: 6px;
//     border: 1px solid black;
//     cursor: pointer;
// `;

interface IBackBtn {
    title?: string;
    style?: React.CSSProperties;
}

const BackBtn: React.FC<IBackBtn> = ({ title, style }) => {
    const history = useHistory();
    return (
        <JumpBtn
            borderColor={"#ef3c34"}
            colorOnHover={"#ef3c34"}
            value="Volver"
            onClick={() => history.goBack()}
        />
        // <Container onClick={() => history.goBack()} style={style}>
        //     <AiOutlineRollback style={{ padding: 2 }} />
        //     <span>{title ? title : "Volver"}</span>
        // </Container>
    );
};

export default BackBtn;
